import { GridFilterCellProps } from '@progress/kendo-react-grid'
import { Input, InputChangeEvent } from '@progress/kendo-react-inputs'

import { OptionsProps } from './types'

type InputFilterCellProps = {
  options?: OptionsProps
}

export const inputFilterCell =
  ({ options }: InputFilterCellProps) =>
  (props: GridFilterCellProps): JSX.Element => <InputFilterCell {...props} options={options} />

type InputFilterCellComponentProps = {
  options?: OptionsProps
} & GridFilterCellProps

export const InputFilterCell: React.FC<InputFilterCellComponentProps> = (props) => {
  const onChange = (event: InputChangeEvent) => {
    props.onChange({
      ...event,
      value: event.target.value ?? '',
      operator: props?.options?.operator ? props.options.operator : 'contains',
    })
  }

  return <Input value={props.value} onChange={onChange} style={{ width: '100%' }} />
}
